import { Component } from '@angular/core';

interface TeamMember {
  name: string;
  role: string;
  bio: string;
  imageUrl: string;
  linkedinUrl?: string;
}

@Component({
  selector: 'app-team-page',
  templateUrl: './team-page.component.html',
  styleUrls: ['./team-page.component.css']
})
export class TeamPageComponent {
  isMobileMenuOpen = false;

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  get fullYear(): number {
    return new Date().getFullYear();
  }

  teamMembers: TeamMember[] = [
    {
      name: 'Juliet Mogaba',
      role: 'Co-Founder & Product Lead',
      bio: 'Leads vision, product strategy, and execution. Served as Geography teacher at Abia State (2018). Best part of service year: "The people I met!". Not so best part: "Camp!"',
      imageUrl: '/assets/images/Juliet_HS.png',
      linkedinUrl: 'https://www.linkedin.com/in/juliet-mogaba',
    },
    {
      name: 'Wisdom Thursday',
      role: 'Brand Strategist & Marketing Lead',
      bio: 'You know about corpers.ng, because of him. Drives positioning, messaging and growth. Served as Digital Skills Coach, Kaduna (2023). Best part of service year: "Travelling". Not so best part: "The culture shock"',
      imageUrl: '/assets/images/Wisdom_HS.jpg',
      linkedinUrl: 'https://www.linkedin.com/in/wisdombthursday',
    },
    {
      name: 'Nwachukwu Ossai',
      role: 'Co-Founder & Tech Lead',
      bio: 'He loves building products that help people. Served in Umuahia, 2018. Best part of service year: NCCF. Not so best part: Camp.',
      imageUrl: '/assets/images/Chuks_HS.jpeg',
      linkedinUrl: 'https://linkedin.com/in/nwachukwu-ossai',
    },
  ];
}
